function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t(require("react"), require("nouislider")) : "function" == typeof define && define.amd ? define(["react", "nouislider"], t) : (e = e || self).ReactNouislider = t(e.React, e.nouislider);
}(this, function (e, t) {
  "use strict";

  function n(e) {
    return (n = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    })(e);
  }

  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function o(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function i() {
    return (i = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function a(e) {
    return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function l(e, t) {
    return (l = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function u(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  e = e && e.hasOwnProperty("default") ? e.default : e, t = t && t.hasOwnProperty("default") ? t.default : t;

  var c = function c(e, t) {
    return "number" == typeof e && "number" == typeof t ? e === t : "string" == typeof e && "string" == typeof t ? e === t : Array.isArray(e) && Array.isArray(t) ? JSON.stringify(e) === JSON.stringify(t) : "object" === n(e) && "object" === n(t) && s(e, t);
  },
      s = function s(e, t) {
    var n = Object.getOwnPropertyNames(e),
        r = Object.getOwnPropertyNames(t);
    if (n.length != r.length) return !1;

    for (var o = 0; o < n.length; o++) {
      var i = n[o];
      if (e[i] !== t[i]) return !1;
    }

    return !0;
  },
      f = function (n) {
    function s() {
      var t, n, r, i;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, s);

      for (var l = arguments.length, c = new Array(l), f = 0; f < l; f++) {
        c[f] = arguments[f];
      }

      return r = this, i = (t = a(s)).call.apply(t, [this].concat(c)), n = !i || "object" != _typeof(i) && "function" != typeof i ? u(r) : i, o(u(n), "sliderContainer", e.createRef()), o(u(n), "clickOnPip", function (e) {
        var t = Number(e.target.getAttribute("data-value"));
        n.slider.set(t);
      }), o(u(n), "toggleDisable", function (e) {
        var t = n.sliderContainer.current;
        t && (e ? t.setAttribute("disabled", !0) : t.removeAttribute("disabled"));
      }), o(u(n), "updateRange", function (e) {
        n.sliderContainer.current.noUiSlider.updateOptions({
          range: e
        });
      }), n;
    }

    var f, p, d;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && l(e, t);
    }(s, e.Component), f = s, (p = [{
      key: "componentDidMount",
      value: function value() {
        var e = this,
            t = this.props,
            n = t.clickablePips,
            r = t.disabled,
            o = this.sliderContainer.current;
        o && (this.toggleDisable(r), this.createSlider(), n && o.querySelectorAll(".noUi-value").forEach(function (t) {
          t.style.cursor = "pointer", t.addEventListener("click", e.clickOnPip);
        }));
      }
    }, {
      key: "shouldComponentUpdate",
      value: function value(e) {
        var t = this.props,
            n = t.start,
            r = t.disabled,
            o = t.range;
        return !c(e.start, n) || e.disabled !== r || !c(e.range, o);
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        var e = this.props,
            t = e.start,
            n = e.disabled,
            r = e.range;
        this.updateRange(r), this.slider.set(t), this.toggleDisable(n);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        if (this.slider && this.slider.destroy(), this.sliderContainer.current) {
          var e = this.sliderContainer.current.querySelector(".noUi-value");
          e && e.removeEventListener("click", this.clickOnPip);
        }
      }
    }, {
      key: "createSlider",
      value: function value() {
        var e = this.props,
            n = e.onUpdate,
            r = e.onChange,
            i = e.onSlide,
            a = e.onStart,
            l = e.onEnd,
            u = e.onSet,
            c = t.create(this.sliderContainer.current, function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {},
                r = Object.keys(n);
            "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
              return Object.getOwnPropertyDescriptor(n, e).enumerable;
            }))), r.forEach(function (t) {
              o(e, t, n[t]);
            });
          }

          return e;
        }({}, this.props));
        this.slider = c, a && c.on("start", a), i && c.on("slide", i), n && c.on("update", n), r && c.on("change", r), u && c.on("set", u), l && c.on("end", l);
      }
    }, {
      key: "render",
      value: function value() {
        var t = this.props,
            n = t.id,
            r = t.className,
            o = t.style,
            a = {};
        return n && (a.id = n), r && (a.className = r), e.createElement("div", i({}, a, {
          ref: this.sliderContainer,
          style: o
        }));
      }
    }]) && r(f.prototype, p), d && r(f, d), s;
  }();

  return f.defaultProps = {
    animate: !0,
    behaviour: "tap",
    className: null,
    clickablePips: !1,
    connect: !1,
    direction: "ltr",
    disabled: !1,
    margin: null,
    limit: null,
    keyboardSupport: !0,
    id: null,
    padding: 0,
    pips: null,
    snap: !1,
    step: null,
    style: null,
    orientation: "horizontal",
    tooltips: !1,
    onChange: function onChange() {},
    onEnd: function onEnd() {},
    onSet: function onSet() {},
    onSlide: function onSlide() {},
    onStart: function onStart() {},
    onUpdate: function onUpdate() {}
  }, f;
});